import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import { Image, TextInput } from "hesus-ui-kit";
import CommentEditor from "./CommentEditor";
import {
  labelStyles,
  inputStyles,
} from "@utils/extra-style";
import { GridRow, GridCell, FlexRow } from "../../AddEditInvoice.styled";
import "../../AddEditInvoice.scss";

const AdditionalDocumentInformation = ({
  t,
  isEditMode,
  formData,
  onFormChange,
  descriptionData,
  setDescriptionData,
  isCommentDataLoaded,
}) => {
  const [commentEditorOpen, setCommentEditorOpen] = useState({
    clientCommentBefore: false,
    clientCommentAfter: false,
  });

  useEffect(() => {
    if (!isCommentDataLoaded) {
      return;
    }
    if (isEditMode) {
      setCommentEditorOpen({
        clientCommentBefore: !!descriptionData?.clientCommentBefore?.trim(),
        clientCommentAfter: !!descriptionData?.clientCommentAfter?.trim(),
      });
    }
  }, [isCommentDataLoaded, isEditMode]);

  return (
    <>
      <GridRow background="#008395" borderRadius="5px 5px 0 0px">
        <GridCell fontWeight="700" fontSize="16px">
          {t("CLIENT_INVOICING_SECTION_ADDITIONAL_INFO")}
        </GridCell>
      </GridRow>
      <GridRow
        column="1fr 1fr"
        boxShadow="0px 1px 1px 1px #e5e5e5"
        margin="0 0 12px 0"
      >
        <FlexRow>
          <div style={{ marginTop: "0rem" }}>
            <Image
              src={
                formData.hasAppendedSummaries.value ? enableIcon : disableIcon
              }
              alt={t("CLIENT_INVOICING_APPEND_SUMMARIES")}
              title={t("CLIENT_INVOICING_APPEND_SUMMARIES")}
              styles={{ width: "auto" }}
              onClick={() =>
                onFormChange(
                  "hasAppendedSummaries",
                  !formData.hasAppendedSummaries.value
                )
              }
            />
            <label className="label add-edit-invoice__active-label">
              {t("CLIENT_INVOICING_APPEND_SUMMARIES")}
            </label>
          </div>
          <div>
            <CommentEditor
              type="clientCommentBefore"
              label="CLIENT_INVOICING_COMMENT_BEFORE_SERVICES"
              value={descriptionData?.clientCommentBefore || ""}
              isEditorOpen={commentEditorOpen.clientCommentBefore}
              setEditorOpen={setCommentEditorOpen}
              setDescriptionData={setDescriptionData}
            />
          </div>
          <div>
            <CommentEditor
              type="clientCommentAfter"
              label="CLIENT_INVOICING_COMMENT_AFTER_SERVICES"
              value={descriptionData?.clientCommentAfter || ""}
              isEditorOpen={commentEditorOpen.clientCommentAfter}
              setEditorOpen={setCommentEditorOpen}
              setDescriptionData={setDescriptionData}
            />
          </div>
          <TextInput
            type="text"
            label={t("CLIENT_INVOICING_LINK_TO_SUMMARIES")}
            name="invoice-upsert-link-summary"
            id="invoice-upsert-link-summary"
            isFloat
            value={String(formData.linkToSummaries.value)}
            onChange={(e) => onFormChange("linkToSummaries", e.target.value)}
            containerStyles={{ marginTop: "21px", maxWidth: "320px" }}
            labelStyles={labelStyles}
            inputStyles={inputStyles}
            placeholder={t("CLIENT_INVOICING_LINK_TO_SUMMARIES")}
          />
        </FlexRow>
        <GridRow padding="0px">
          <CommentEditor
            type="internalComment"
            label="CLIENT_INVOICING_INTERNAL_COMMENTS"
            value={descriptionData?.internalComment || ""}
            isEditorOpen={commentEditorOpen.internalComment}
            setEditorOpen={setCommentEditorOpen}
            setDescriptionData={setDescriptionData}
            alwaysOpen
          />
        </GridRow>
      </GridRow>
    </>
  );
};

AdditionalDocumentInformation.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  updateRefreshStatus: PropTypes.func,
};

AdditionalDocumentInformation.defaultProps = {
  isEditMode: false,
  id: null,
  updateRefreshStatus: null,
};

export default withTranslation()(AdditionalDocumentInformation);
